module.exports = __webpack_public_path__ + "2bdfa1818cd40a871ca02d570ec5dd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/ItamarDavidyan.jpg
// module id = 31
// module chunks = 0